import { render, staticRenderFns } from "./advancedAudience.vue?vue&type=template&id=bcdb1e94&scoped=true"
import script from "./advancedAudience.vue?vue&type=script&lang=js"
export * from "./advancedAudience.vue?vue&type=script&lang=js"
import style0 from "./advancedAudience.vue?vue&type=style&index=0&id=bcdb1e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdb1e94",
  null
  
)

export default component.exports